var _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactNormalDeschisActionarePrinApasare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 83,
    viewBox: "0 0 76 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33.9023L38 0.000101737",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 82.6016V48.5431",
    stroke: "black",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 44,
    x2: 10,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 44,
    x2: 30,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 31,
    y1: 44,
    x2: 34,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 44,
    x2: 20,
    y2: 44,
    stroke: "black",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 58,
    x2: 1,
    y2: 30,
    stroke: "black",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 58,
    x2: 1,
    y2: 30,
    stroke: "black",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 57,
    x2: 16,
    y2: 57,
    stroke: "black",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: 30,
    x2: 15,
    y2: 30,
    stroke: "black",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 29L38.6028 49.7332",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactNormalDeschisActionarePrinApasare);
export default __webpack_public_path__ + "static/media/contact_normal_deschis_actionare_prin_apasare.a1c5a34a9dc31f771dc8ccd4cfdccc0d.svg";
export { ForwardRef as ReactComponent };